<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CATG_GRP_NM')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="categoryName"
              placeholder
              maxlength="50"
              :disabled="false"
              :readonly="false"
              @input="specialChar(categoryName)"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CATG_GRP_ID')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              BCG_
            </div>
            <div class="comp_spacing" />
            <sui-text-field
              v-model="categoryId"
              placeholder
              maxlength="26"
              :disabled="false"
              :readonly="false"
              @input="specialChar(categoryId)"
            />
            <div class="comp_spacing" />
            <sui-button
              type="button"
              class="comm_btn_duplicate"
              @click="onClickDuplicate"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DESC')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              v-model="categoryContent"
              placeholder
              maxlength="1000"
              :disabled="false"
              :readonly="false"
              @input="specialChar(categoryContent)"
            />
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="gridN"
        :columns="gridColumns0"
        :dataset="'dataset0'"
        :showDisplayCountControl="true"
        :rowMovable="true"
        :multiselect="false"
        :pageable="false"
        @rowselect="onSelectRow"
      >
        <div class="btn_wrapL">
          <div class="comp_spacing" />
          <sui-button
            v-permission:create="contextPageId"
            type="button"
            class="comm_btn_gridTop"
            @click="onClickAddRow"
          >
            {{ $t('MSG_BTN_ROW_ADD') }}
          </sui-button>
          <sui-button
            v-permission:create="contextPageId"
            type="button"
            class="comm_btn_gridTop"
            :disabled="deleteStatus"
            @click="onClickDeleteRow"
          >
            {{ $t('MSG_BTN_ROW_DEL') }}
          </sui-button>
        </div>
      </sui-grid>
    </div>
    <div class="comm_btn_wrap mrB30 mrR30">
      <div class="btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onPopupCancelClicked"
        >
          {{ $t('MSG_BTN_CANCEL') }}
        </sui-button>
        <sui-button
          v-permission:create="contextPageId"
          type="button"
          class="comm_btn_solid"
          @click="applyRegistration"
        >
          {{ $t('MSG_BTN_SAVE') }}
        </sui-button>
      </div>
    </div>
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CLB_00007_P01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    biddingInformationParam: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      registrationdate: '',
      categoryId: '',
      categoryContent: '',
      categoryName: '',
      isemptyItem: false,
      isEmptydata: false,
      isemptyOrder: false,
      duplicateCheckValue: false,
      deleteStatus: true,
    };
  },
  computed: {},
  watch: {},
  datasets: [
    {
      id: 'dataset0',
      type: 'local',
      data: 'localdata0',
      datafields: [
        {
          name: 'itemName',
          type: 'string',
          map: 'itemName',
        },
        {
          name: 'aryl_order',
          type: 'string',
          map: 'aryl_order',
        },
        {
          name: 'registrant',
          type: 'string',
          map: 'registrant',
        },
        {
          name: 'registrationDate',
          type: 'string',
          map: 'registrationDate',
        },
        {
          name: 'multiLanguageList',
          type: 'array',
          map: 'multiLanguageList',
        },
      ],
    },
  ],
  created() {
    this.localdata0 = [];
    this.gridColumns0 = [
      {
        text: this.$t('MSG_TXT_NUMBER_ROW'),
        datafield: '',
        cellsalign: 'center',
        editable: false,
        width: 80,
        cellsrenderer: (row, column, value) => `<div style="margin: 8.2px;">${row + 1}</div>`,
      },
      {
        text: this.$t('MSG_TXT_CATG_GRP_ITEM'),
        datafield: 'multiLanguageList',
        editable: true,
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellMlngEditor(row, column, value, htmlElement, {
            pageId: this.contextPageId,
          },
          this.dataset0, this.$refs.gridN);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
      {
        text: this.$t('MSG_TXT_ARRAY_ORDER'),
        datafield: 'aryl_order',
        editable: true,
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
            trim: true,
            maxlength: '2',
            mask: 'number',
          },
          this.dataset0,
          this.$refs.gridN);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: 100,
      },
      // {
      //   text: this.$t('MSG_TXT_RGST_USR'),
      //   datafield: 'registrant',
      //   createwidget: (row, column, value, htmlElement) => {
      //     utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
      //       displayType: '1', // "1", "2" - default: "1"
      //       type: 'link', // 'link', 'sublink' - default: "link"
      //     },
      //     this.dataset0,
      //     this.$refs.gridN);
      //   },
      //   initwidget(row, column, value, htmlElement) {
      //     utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      //   },
      //   width: 100,
      // },
      // {
      //   text: this.$t('MSG_TXT_RGST_DTM'),
      //   datafield: 'registrationDate',
      //   width: 150,
      //   createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.dataset0, this.$refs.gridN),
      //   initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),
      // },
    ];
  },
  methods: {
    onSelectRow(id) {
      this.deleteStatus = false;
    },
    onClickDuplicate() {
      const queryParams = {
        categoryId: `BCG_${this.categoryId.trim()}`,
      };
      http
        .request(this.contextPageId, 'DTS_CLB_00035', {
          query: queryParams,
        })
        .then(res => {
          if (res.data.resultCode === '0') {
            this.duplicateCheckValue = true;
            utils.messageBox(
              'warning',
              utils.strFormat(
                this.$t('MSG_ALT_BE_RGST_OK'),
                this.$t('MSG_TXT_CATG_GRP_ID'),
                null,
              ),
            );
          } else {
            utils.messageBox(
              'warning',
              this.$t('MSG_ALT_DUPLICATE_EXISTS'),
              null,
              null,
            );
          }
        });
    },
    specialChar(value) {
      if (value === this.categoryId) {
        this.duplicateCheckValue = false;
      }
      if (utils.isExistSpecialChar(value)) {
        utils.messageBox(
          'warning',
          this.$t('MSG_ALT_CHK_SPECL_CHAR'),
          null,
          () => {
            if (value === this.categoryName) this.categoryName = '';
            else if (value === this.categoryId) this.categoryId = '';
            else if (value === this.categoryContent) this.categoryContent = '';
          },
        );
      }
    },
    onClickDeleteRow() {
      const selectedIndexes = this.dataset0.getSelectedIndexes();
      this.dataset0.deleteRows(selectedIndexes);
      this.deleteStatus = true;
    },
    applyRegistration() {
      if (this.dataset0.data.length < 1) {
        this.isEmptydata = true;
      } else this.isEmptydata = false;
      this.isemptyItem = false;
      this.isemptyOrder = false;
      this.dataset0.data.forEach(element => {
        if (element.itemName === '') {
          // this.isemptyItem = true;
        }
        if (!element.aryl_order) {
          this.isemptyOrder = true;
        }
      });
      if (!this.categoryName.trim()) {
        utils.messageBox(
          'warning',
          utils.strFormat(
            this.$t('MSG_ALT_INPUT_CELL'),
            this.$t('MSG_TXT_CATG_GRP_NM'),
            null,
          ),
        );
      } else if (!this.categoryId.trim()) {
        utils.messageBox(
          'warning',
          utils.strFormat(
            this.$t('MSG_ALT_INPUT_CELL'),
            this.$t('MSG_TXT_CATG_GRP_ID'),
            null,
          ),
        );
      } else if (!this.categoryContent.trim()) {
        utils.messageBox(
          'warning',
          utils.strFormat(
            this.$t('MSG_ALT_INPUT_CELL'),
            this.$t('MSG_TXT_DESC'),
            null,
          ),
        );
      } else if (!this.duplicateCheckValue) {
        utils.messageBox(
          'warning',
          utils.strFormat(this.$t('MSG_ALT_SELT_DPCT_CHK'), null),
        );
      } else if (this.isEmptydata) {
        utils.messageBox(
          'warning',
          utils.strFormat(
            this.$t('MSG_ALT_INPUT_CELL'),
            this.$t('MSG_TXT_CATG_GRP_ITEM'),
            null,
          ),
        );
      } else if (this.isemptyItem) {
        utils.messageBox(
          'warning',
          utils.strFormat(
            this.$t('MSG_ALT_INPUT_CELL'),
            this.$t('MSG_TXT_CATG_GRP_ITEM'),
            null,
          ),
        );
      } else if (this.isemptyOrder) {
        utils.messageBox(
          'warning',
          utils.strFormat(
            this.$t('MSG_ALT_INPUT_CELL'),
            this.$t('MSG_TXT_ARRAY_ORDER'),
          ),
          null,
        );
      } else {
        const positiveHandler = this.submitRequest;
        utils.messageBox(
          'confirm',
          this.$t('MSG_ALT_IS_SAV_DATA'),
          null,
          positiveHandler,
        );
      }
    },
    submitRequest() {
      const categoryItemlist = [];
      const categoryGroupId = `BCG_${this.categoryId.trim()}`;
      utils.forEach(this.dataset0.data, (row, index) => {
        const find = utils.find(row.multiLanguageList, { langId: this.$store.getters.userInfo.langId });
        const data = {
          arraylOrder: row.aryl_order,
          bullBoardCategoryGroupID: categoryGroupId,
          bullBoardCategoryGroupName: this.categoryName.trim(),
          bullBoardCategoryGroupContent: this.categoryContent.trim(),
          bullBoardCategoryItemName: find.multiLanguageContent,
          bullBoardCategoryItemID: `${categoryGroupId}_0${index + 1}`,
          categoryItemMultiLanguageList: row.multiLanguageList,
        };
        categoryItemlist.push(data);
      });
      http
        .request(this.contextPageId, 'DTS_CLB_00036', {
          data: categoryItemlist,
        })
        .then(res => {
          if (res.data.resultCode === '1') {
            utils.messageBox('success', this.$t('MSG_ALT_PRGS_OK'), null);
          }
          this.$emit('exit', 'register');
        });
    },
    onPopupCancelClicked() {
      this.$emit('exit', 'cancelRegister');
    },
    onClickAddRow() {
      const dateObj = new Date();
      const FORMAT_STR_SERVER = 'YYYYMMDDHHmmss';
      this.registrationdate = utils.toStringByFormat(
        dateObj,
        FORMAT_STR_SERVER,
      );
      const defaultRow = [
        {
          registrationDate: this.registrationdate,
          knoxId: this.$store.getters.userInfo.knoxId,
          userName: this.$store.getters.userInfo.userName,
          userGlobalName: this.$store.getters.userInfo.userGlobalName,
          itemName: '',
        },
      ];
      this.dataset0.addRows(defaultRow, true);
    },
  },
};
</script>
<style scoped>
</style>
